module.exports = __webpack_public_path__ + "img/groupBig.56a3f3a8.png";